module.exports = function ($, M) {
  'use strict';

  // Setup
  M.profile = {};

  $.extend(true, M.profile, {
    update_json_setting: function (key, value, callback) {
      $.ajax({
        url: '/ajax/accounts/update_setting/',
        type: 'POST',
        data: {
          key: key,
          value: value,
        },
        success: function (res) {
          M.user.profile.settings[key] = value;
          if (typeof callback === 'function') {
            callback(res);
          }
        },
      });
    },
  });

  $('#disconnect').on('click', function (e) {
    e.preventDefault();
    $.ajax({
      url: '/accounts/disconnect/facebook/',
      type: 'POST',
      complete: function (data) {
        if (data.status === 200) {
          window.location = '/home/?disconnected=true';
        }
      },
      error: function () {
        M.modal.error(
          _t('Oops, something went wrong. Please try again later!'),
        );
      },
    });
  });
};
